export default "__VITE_ASSET__BEvjG1gY__"